module.exports = __webpack_public_path__ + "img/question12c3.a8be419e.png";